module.exports = __webpack_public_path__ + "img/KE.c321bc40.svg";